
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import React, { useState, useEffect, useRef } from 'react';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import Toast from '../../Shared/Toast/Toast';
import { FloatLabel } from 'primereact/floatlabel';
import { useCatchResponse } from '../../../utils/useCatchResponse';

const AddSectionMasterDialog = (props) => {
    const { catchResponse } = useCatchResponse();
    const [securityUserID, setSecurityUserID] = useState("");
    const [sectionName, setSectionName] = useState('');
    const [sectionNameErrText, setSectionNameErrText] = useState('');
    const [sectionNameErr, setSectionNameErr] = useState(false);
    const [totalCapacity, setTotalCapacity] = useState('');
    const [totalCapacityErrText, setTotalCapacityErrText] = useState('');
    const [totalCapacityErr, setTotalCapacityErr] = useState(false);

    const submitButtonRef = useRef(null);
    const sectionNameRef = useRef(null);
    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);

        if (props.ID) {
            setSectionName(props?.masterData?.SectionName);
            setTotalCapacity(props?.masterData?.TotalCapacity);
        }

        setTimeout(() => {
            sectionNameRef.current?.focus();
        }, 100);
    }, []);


    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        if (props.ID) {
            setSectionName(props?.masterData?.SectionName);
            setTotalCapacity(props?.masterData?.TotalCapacity);
        }

    }, []);

    const onCancel = () => {
        props.onCancel();
        setSectionName('');
        setTotalCapacity('');
    }

    const validate = () => {
        let formIsValid = true;
        if (CommonConfig.isEmpty(sectionName)) {
            formIsValid = false;
            setSectionNameErr(true);
            setSectionNameErrText("Section Name is required");
        } else {
            setSectionNameErr(false);
            setSectionNameErrText("");
        }
        if (CommonConfig.isEmpty(totalCapacity)) {
            formIsValid = false;
            setTotalCapacityErr(true);
            setTotalCapacityErrText("Total Capacity is required");
        } else {
            setTotalCapacityErr(false);
            setTotalCapacityErrText("");
        }
        return formIsValid;
    };

    const AddSectionMaster = async (e) => {
        if (validate(e)) {
            try {
                Loader.show();
                let data = {
                    id: props.ID,
                    SectionName: sectionName.trim().replace(/\s+/g, ' '),
                    TotalCapacity: totalCapacity.trim().replace(/\s+/g, ' '),
                    CreatedBy: securityUserID,
                };

                await api
                    .post(APIConstant.path.AddUpdateSectionMaster, data)
                    .then((response) => {
                        let res = response;
                        if (res.success) {
                            Toast.success({ message: res.message });
                            Loader.hide();
                            onCancel();
                        } else {
                            Toast.error({ message: res.message });
                            Loader.hide();
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        Loader.hide();
                        onCancel();
                    });
            } catch (err) {
                console.log(err);
                Loader.hide();
                onCancel();
                catchResponse(err);
            }
        }
    };

    const handleChange = (e, type) => {
        const value = e.target.value;
        const numericValue = value.replace(/[^0-9]/g, '');
        const alphanumericValue = value.replace(/[^a-zA-Z0-9\s!@#$%^&*\u0A80-\u0AFF\u0900-\u097F\s]/g, '');

        if (type === 'SectionName') {
            setSectionName(alphanumericValue);
        } else if (type === 'Capacity') {
            setTotalCapacity(numericValue);
        }
    };

    return (
        <div>
            <div className='p-grid'>
                <div className="p-col-12 p-md-6 p-pt-2">
                    <label htmlFor="clasName">Section Name<span style={{ color: "red" }}>*</span></label>
                    <div className="custom-inputs">
                        <FloatLabel>
                            <InputText
                                ref={sectionNameRef}
                                className="p-mt-2 p-pl-2 p-w-100"
                                id="sectionName"
                                type="text"
                                maxLength={20}
                                placeholder="Section Name"
                                value={sectionName}
                                onChange={(e) => handleChange(e, 'SectionName')}
                            />

                        </FloatLabel>
                        <span className="error-msg" style={{ color: 'red' }}>
                            {sectionNameErr ? sectionNameErrText : null}
                        </span>
                    </div>
                </div>
                <div className="p-col-12 p-md-6 p-pt-2">
                    <label htmlFor="totalCapacity">Total Capacity<span style={{ color: "red" }}>*</span></label>
                    <div className="custom-inputs">
                        <FloatLabel>
                            <InputText
                                className="p-mt-2 p-pl-2 p-w-100"
                                id="totalCapacity"
                                maxLength={5}
                                placeholder="Total Capacity"
                                value={totalCapacity}
                                autoFocus={true}
                                onChange={(e) => handleChange(e, 'Capacity')}
                                onKeyDown={(e) => {
                                    if (e.key === 'Tab' && !e.shiftKey) {
                                        e.preventDefault();
                                        if (submitButtonRef.current) {
                                            submitButtonRef.current.focus();
                                        }
                                    }
                                }}
                            />
                        </FloatLabel>
                        <span className="error-msg" style={{ color: 'red' }}>
                            {totalCapacityErr ? totalCapacityErrText : null}
                        </span>
                    </div>
                </div>

            </div>
            <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
                <Button className='btn-text-action-secondary' onClick={(e) => onCancel()}> cancel </Button>
                <Button ref={submitButtonRef} className='btn-text-action-primary submit-focus' label="Save" severity="secondary" raised onClick={(e) => AddSectionMaster()} />
            </div>
        </div>
    );
};

export default AddSectionMasterDialog;
